<template>
  <div class="add_favourite" v-if="seen">
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" width="40px"
        height="40px" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;">
        <circle cx="50" cy="50" fill="none" stroke-linecap="round" stroke="#039aed" r="30"
          stroke-dasharray="41.41592653589793 41.41592653589793" stroke-width="8">
          <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
            keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
        </circle>
      </svg>
      Adding files to favourite
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      seen: false,
      index: null
    }
  },
  methods: {
    ...mapMutations([
      'EMPTY_FILE_ACTION'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    add() {
      let data = {
        token: cookies.getCookie('token'),
        files: this.$store.getters.GET_FILE_ACTION
      }

      let that = this

      this.$socket.emit('group-add-to-favourite', data, function (data) {
        that.seen = false
        if (data.data === true) {
          for (let i = 0; i < that.$store.getters.GET_FILE_ACTION.length; i++) {
            let index = that.$store.getters.GET_FILES_INDEX[that.$store.getters.GET_FILE_ACTION[i]]
            that.$store.getters.DIRECTORY_CHILDREN[index].is_favourite = true
            that.$store.getters.DIRECTORY_CHILDREN[index].is_checked = false
          }

          that.EMPTY_FILE_ACTION()
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    }
  }
}
</script>
